<script>
export default {
    name: 'Modal',
    methods: {
        close() {
            this.$emit('close');
        },
        requestCall() {
            this.$emit("request");
        }
    },
};
</script>

<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <div class="modal"
                role="dialog"
                aria-labelledby="modalTitle"
                aria-describedby="modalDescription">
                <header class="modal-header" id="modalTitle">
                    <button
                        type="button"
                        class="btn-close"
                        @click="close"
                        aria-label="Close modal">
                        x
                    </button>
                </header>

                <section class="modal-body" id="modalDescription">  
                    <div class="row">
                        <div class="col-md-8 offset-md-2 col-10 offset-1">
                            <div class="h4 font-weight-bolder mt-2 mb-3">Watch this 1-min video to know more about coders's starter kit</div> 
                            <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/aIGRJ63FQmk?rel=0" allowfullscreen></iframe>
                            <div class="text-muted my-2">
                                Interested in this ? Book a free counselling call to understand how this can be a life changing experience for your child.
                            </div>
                        </div>
                    </div>
                </section>

                <footer class="custom-modal-footer">
                    <div class="row">
                        <div class="col-md-6 offset-md-3 col-8 offset-2">
                            <button
                                type="submit"
                                @click="requestCall"
                                class="btn-orangy btn-block"
                                aria-label="Close modal">
                                Request a Call
                            </button>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    </transition>
</template>


<style lang="scss" scoped>
$orange-color: #DF711B;

@media only screen and (min-width: 1025px) {
    .modal {
        width: 60vw;
        height: 90vh;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
}

.modal {
    background: #fff;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
}

.modal-header,
.custom-modal-footer {
    padding: 15px;
    
}
iframe {
    height: 300px !important;
    width: 100%;
    border: none;
}
.modal-header {
    position: relative;
    display: flex;
    color: black;
    font-weight: 600;
    justify-content: space-between;
    box-shadow: none;
    border-bottom: none;
}

.custom-modal-footer {
    border-top: 1px solid #eeeeee;
    align-items: center;
    justify-content: center;
}

.modal-body {
    position: relative;
    padding: 1.25rem;
    overflow-x: hidden;
    
}

.btn-close {
    position: absolute;
    top: 0;
    right: 2%;
    border: none;
    font-size: 24px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: black;
    background: transparent;
}
.btn-orangy {
    background: $orange-color;
    border: 1px solid $orange-color;
    padding: 0.8rem 8rem;
}
.btn-orangy, .btn-secondary {
    color: white;
    font-weight: 600;
    padding: 0.8rem 4rem;
    border-radius: 25px;
}
.btn-orangy:focus {
    outline:none;
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease;
}

</style>